// AdminContainer.js

import React, { useState } from "react";
import AdminProductDetails from "../AdminProductDetails/AdminProductDetails";
import ProductList from "../ProductList/AdminProductList";
import AdminOrderList from "../Orders/AdminOrderList";
import OrderDetails from "../Orders/OrderDetails";
import AdminDeliveryDashboard from "../Orders/AdminDeliveryDashboard";
import AdminBottleReturnsDashboard from "../BottleReturns/AdminBottleReturnsDashboard";
import VideoManager from "../VideoPlaylist/VideoManager";
import AdminSubscriptionSettings from "./AdminSubscriptionSettings";
import AdminSubscriptionDashboard from "./AdminSubscriptionDashboard";
import AdminNotifications from "./AdminNotifications";
import MigratePasswordsButton from "./MigratePasswordsButton";
import AdminUserDetails from "./AdminUserDetails";
import "./AdminContainer.scss";

const AdminContainer = (props) => {
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [showProductList, setShowProductList] = useState(true);
  const [showVideos, setShowVideos] = useState(false);
  const [showDelivery, setShowDelivery] = useState(false);
  const [showBottleReturns, setShowBottleReturns] = useState(false);
  const [showSubscriptions, setShowSubscriptions] = useState(false);
  const [showSubscriptionSettings, setShowSubscriptionSettings] = useState(false);
  const [showNotifications, setShowNotifications] = useState(false);
  const [showUserDetails, setShowUserDetails] = useState(false);

  const handleProductDetails = (product) => {
    console.log("Selected product:", product);
    setSelectedProduct(product._id);
  };
  
  const handleOrderDetails = (order) => {
    setSelectedOrder(order);
  };
  
  const onBackClickToProductList = () => {
    setSelectedProduct(null);
    setSelectedOrder(null);
    setShowProductList(true);
  }
  
  const onBackClickToOrderDetails = () => {
    setSelectedProduct(null);
    setSelectedOrder(null);
    setShowProductList(false);
  }

  const resetAllStates = () => {
    setShowProductList(false);
    setShowVideos(false);
    setShowDelivery(false);
    setShowBottleReturns(false);
    setShowSubscriptions(false);
    setShowSubscriptionSettings(false);
    setShowNotifications(false);
    setShowUserDetails(false);
    setSelectedOrder(null);
  };

  return (
    <div className="admin-container">
      {selectedProduct ? (
        <div className="details-container">
          <AdminProductDetails productId={selectedProduct} onBackClick={onBackClickToProductList} />
        </div>
      ) : (
        <>
          <div className="admin-section">
            <div className="admin-navigation">
              <button 
                type="button"
                className={showProductList ? "active" : ""} 
                onClick={() => {
                  resetAllStates();
                  setShowProductList(true);
                }}
              >
                Products
              </button>
              <button 
                type="button"
                className={!showProductList && !showVideos && !showDelivery && !showSubscriptions && !showSubscriptionSettings ? "active" : ""} 
                onClick={() => {
                  resetAllStates();
                }}
              >
                Orders
              </button>
              <button 
                type="button"
                className={showDelivery ? "active" : ""} 
                onClick={() => {
                  resetAllStates();
                  setShowDelivery(true);
                }}
              >
                Deliveries
              </button>
              <button 
                type="button"
                className={showBottleReturns ? "active" : ""} 
                onClick={() => {
                  resetAllStates();
                  setShowBottleReturns(true);
                }}
              >
                Bottle Returns
              </button>
              <button 
                type="button"
                className={showSubscriptions ? "active" : ""} 
                onClick={() => {
                  resetAllStates();
                  setShowSubscriptions(true);
                }}
              >
                Subscriptions
              </button>
              <button 
                type="button"
                className={showSubscriptionSettings ? "active" : ""} 
                onClick={() => {
                  resetAllStates();
                  setShowSubscriptionSettings(true);
                }}
              >
                Sub Settings
              </button>
              <button 
                type="button"
                className={showVideos ? "active" : ""} 
                onClick={() => {
                  resetAllStates();
                  setShowVideos(true);
                }}
              >
                Videos
              </button>
              <button 
                type="button"
                className={showNotifications ? "active" : ""} 
                onClick={() => {
                  resetAllStates();
                  setShowNotifications(true);
                }}
              >
                Notifications
              </button>
              <button 
                type="button"
                className={showUserDetails ? "active" : ""} 
                onClick={() => {
                  resetAllStates();
                  setShowUserDetails(true);
                }}
              >
                User Details
              </button>
            </div>
            
            <div className="admin-tools">
              <MigratePasswordsButton />
            </div>
          </div>
          <div>
            {showVideos ? (
              <div className="video-manager-container">
                <VideoManager />
              </div>
            ) : showDelivery ? (
              <div className="delivery-dashboard-container">
                <AdminDeliveryDashboard />
              </div>
            ) : showBottleReturns ? (
              <div className="bottle-returns-container">
                <AdminBottleReturnsDashboard />
              </div>
            ) : showSubscriptions ? (
              <div className="subscription-dashboard-container">
                <AdminSubscriptionDashboard />
              </div>
            ) : showSubscriptionSettings ? (
              <div className="subscription-settings-container">
                <AdminSubscriptionSettings />
              </div>
            ) : showNotifications ? (
              <div className="notifications-container">
                <AdminNotifications />
              </div>
            ) : showUserDetails ? (
              <div>
                <AdminUserDetails />
              </div>
            ) : showProductList ? (
              <div className="product-list-container">
                <ProductList handleProductDetails={handleProductDetails} />
              </div>
            ) : (
              <div className="order-list-container">
                {selectedOrder ? (
                  <div className="details-container">
                    <OrderDetails orderId={selectedOrder.orderId} onBackClick={onBackClickToOrderDetails} />
                  </div>
                ) : (
                  <div>
                    <AdminOrderList handleOrderDetails={handleOrderDetails} />
                  </div>
                )}
              </div>
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default AdminContainer;